import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { fetchTarifas, createTarifa, updateTarifa, deleteTarifa } from '../../api/worklog';
import { fetchAnalistas } from '../../api/usuarios';
import './Worklog.css';

function moeda(v) { return Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }

function Tarifas() {
    const history = useHistory();
    const [tarifas, setTarifas] = useState([]);
    const [analistas, setAnalistas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mensagem, setMensagem] = useState('');
    const [show, setShow] = useState(false);
    const [usuarioId, setUsuarioId] = useState('');
    const [cliente, setCliente] = useState('');
    const [valor, setValor] = useState('');
    const [salvando, setSalvando] = useState(false);

    const verificar = useCallback(async () => {
        const ok = await verificandoApp('ATENDENTE');
        if (!ok) history.push('/');
    }, [history]);

    const carregar = useCallback(async () => {
        verificandoToken();
        setLoading(true);
        try { setTarifas(await fetchTarifas()); } finally { setLoading(false); }
    }, []);

    useEffect(() => { verificar(); carregar(); fetchAnalistas().then((l) => setAnalistas(Array.isArray(l) ? l : [])); }, [verificar, carregar]);

    const abrir = () => { setUsuarioId(''); setCliente(''); setValor(''); setMensagem(''); setShow(true); };

    const salvar = async () => {
        const v = Number(String(valor).replace(',', '.'));
        if (Number.isNaN(v) || v < 0) { setMensagem('Informe um valor/hora válido.'); return; }
        setSalvando(true);
        try {
            await createTarifa({ usuario_id: usuarioId || null, cliente: cliente || null, valor_hora: v });
            setShow(false);
            await carregar();
        } catch (e) {
            setMensagem(e?.response?.data?.error || 'Erro ao salvar tarifa.');
        } finally { setSalvando(false); }
    };

    const editarValor = async (t) => {
        const novo = window.prompt(`Novo valor/hora para ${t.colaborador || 'padrão'}${t.cliente ? ' · ' + t.cliente : ''}:`, String(t.valor_hora));
        if (novo == null) return;
        const v = Number(String(novo).replace(',', '.'));
        if (Number.isNaN(v) || v < 0) { setMensagem('Valor inválido.'); return; }
        try { await updateTarifa(t.id, { valor_hora: v }); await carregar(); }
        catch (e) { setMensagem(e?.response?.data?.error || 'Erro ao atualizar.'); }
    };

    const remover = async (t) => {
        if (!window.confirm('Remover esta tarifa?')) return;
        try { await deleteTarifa(t.id); await carregar(); }
        catch (e) { setMensagem(e?.response?.data?.error || 'Erro ao remover.'); }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado wl-page">
                    <div className="page-header d-flex flex-wrap justify-content-between align-items-center gap-2">
                        <div>
                            <h1 className="mb-0"><i className="fas fa-money-bill-wave me-2" />Tarifas (custo/hora)</h1>
                            <p className="text-muted small mb-0">Mais específica vence: colaborador+cliente &gt; colaborador &gt; cliente &gt; padrão.</p>
                        </div>
                        <button type="button" className="btn btn-primary btn-sm" onClick={abrir}><i className="fas fa-plus me-1" />Nova tarifa</button>
                    </div>

                    {mensagem && !show && <div className="alert alert-danger py-2 my-2">{mensagem}</div>}

                    {loading && <p className="text-muted">Carregando...</p>}
                    {!loading && tarifas.length === 0 && <div className="alert alert-info py-3 mt-3">Nenhuma tarifa. Crie ao menos a tarifa padrão (sem colaborador e sem cliente).</div>}

                    {!loading && tarifas.length > 0 && (
                        <div className="table-responsive mt-3">
                            <table className="table table-sm wl-table">
                                <thead><tr><th>Colaborador</th><th>Cliente</th><th className="text-end">Valor/hora</th><th className="text-center">Ativo</th><th></th></tr></thead>
                                <tbody>
                                    {tarifas.map((t) => (
                                        <tr key={t.id}>
                                            <td>{t.usuario_id ? (t.colaborador || ('Usuário ' + t.usuario_id)) : <em className="text-muted">Padrão (todos)</em>}</td>
                                            <td>{t.cliente || <em className="text-muted">Qualquer</em>}</td>
                                            <td className="text-end text-nowrap">{moeda(t.valor_hora)}</td>
                                            <td className="text-center">{t.ativo ? <i className="fas fa-check text-success" /> : <i className="fas fa-times text-muted" />}</td>
                                            <td className="text-end text-nowrap">
                                                <button className="btn btn-link btn-sm p-1" title="Editar valor" onClick={() => editarValor(t)}><i className="fas fa-pen" /></button>
                                                <button className="btn btn-link btn-sm p-1 text-danger" title="Remover" onClick={() => remover(t)}><i className="fas fa-trash" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </main>

            {show && (
                <div className="modal-overlay" onClick={() => !salvando && setShow(false)}>
                    <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                        <h5 className="mb-3"><i className="fas fa-money-bill-wave me-2" />Nova tarifa</h5>
                        <div className="form-group mb-2">
                            <label className="small">Colaborador (vazio = padrão da empresa)</label>
                            <select className="form-control form-control-sm" value={usuarioId} onChange={(e) => setUsuarioId(e.target.value)}>
                                <option value="">Padrão (todos)</option>
                                {analistas.map((a) => <option key={a.USUSEQ ?? a.ususeq} value={a.USUSEQ ?? a.ususeq}>{a.USRNOMCPL ?? a.usrnomcpl ?? ('Usuário ' + (a.USUSEQ ?? a.ususeq))}</option>)}
                            </select>
                        </div>
                        <div className="form-group mb-2">
                            <label className="small">Cliente (vazio = qualquer)</label>
                            <input className="form-control form-control-sm" value={cliente} onChange={(e) => setCliente(e.target.value)} placeholder="Ex.: Orsegups" />
                        </div>
                        <div className="form-group mb-2">
                            <label className="small">Valor/hora (R$)</label>
                            <input className="form-control form-control-sm" value={valor} onChange={(e) => setValor(e.target.value)} placeholder="Ex.: 150,00" />
                        </div>
                        {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                        <div className="d-flex justify-content-end gap-2">
                            <button type="button" className="btn btn-secondary btn-sm" disabled={salvando} onClick={() => setShow(false)}>Cancelar</button>
                            <button type="button" className="btn btn-primary btn-sm" disabled={salvando} onClick={salvar}>{salvando ? 'Salvando...' : 'Criar'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Tarifas;
